import AmexPlatinumNightsSelector from './AmexPlatinumNightsSelector';

export default AmexPlatinumNightsSelector;
